module.exports = __webpack_public_path__ + "img/mycollection.ae31aea6.svg";